import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Payment, Transaction } from '../../models';
import { TokenServiceService } from '../../services/token-service.service';
import { BuyerInformationComponent } from '../buyer-information/buyer-information.component';
import { AlertService } from 'src/app/services/alert.service';
import { ALERT_ERRORS } from 'src/app/core/constants/Errors';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { COMMERCIAL_NETWORKS_TIMEZONES } from 'src/app/core/constants/CommercialNetwork';
import { TC_FRANCHISE_FROM_FLUTTER } from 'src/app/core/constants/credit-cards.constants';
import { COOPENAE, LAFISE, MOVII, NIUBIZ, PAYMENTEZ, REDEBAN } from 'src/app/core/constants/credit-cards-processor.constants';
import { environment } from 'src/environments/environment';
import {
  ALERT_ICON_CONSTANTS,
  API_PATHS,
  API_V4_RESPONSE_NETWORK_CODES,
  debugLog,
  FLAGS_NAME,
  FLUTTER_POST_MESSAGE_TO_SEND,
  FLUTTER_POST_MESSAGE_TYPES,
  FLUTTER_TC_FORM_STATUS_TYPES,
  GENERAL_CONSTANTS,
  ORDER_STATES,
} from 'src/app/core/constants/General-constants';
import { BehaviorSubject } from 'rxjs';
import { IframeService } from 'src/app/services/iframe.service';
import { MatDialog } from '@angular/material/dialog';
import { WalletDialogComponent } from '../wallet/wallet-dialog/wallet-dialog.component';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';

export interface AddressInfo {
  line1: string;
  line2: string;
  postalCode: string;
}

@Component({
  selector: 'app-embebed-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: Window, useValue: window }],
})
// TODO: TECHNICAL DEBT 28125 https://dev.azure.com/payvalida/payValida/_workitems/edit/28125
export class EmbebedCreditCardComponent implements OnInit {
  private isVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input()
  set isVisible(value: boolean) {
    this.isVisible$.next(value);
  }

  get isVisible(): boolean {
    return this.isVisible$.value;
  }

  @Input() info: Payment;
  @Input() wallet: Payment;
  @Output() TC = new EventEmitter();
  @ViewChild(BuyerInformationComponent)
  creditCardIframeElement: HTMLIFrameElement;
  transaction: Transaction;
  loading = true;
  response: any;
  iframeUrl: string = '';
  loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_TRANSACTION;
  displayMessage = false;
  showAutoExposedTcForm: boolean = true;
  useEmbedWallet: boolean = false;
  token: string;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private tokenService: TokenServiceService,
    private readonly alertService: AlertService,
    private readonly iframeService: IframeService,
    private readonly dialog: MatDialog,
    private readonly featureFlagService: PayvalidaFeatureFlagService
  ) {}

  async ngOnInit() {
    this.iframeUrl = `${environment.modulesPayvalidaUrl}${API_PATHS.creditCardForm}`;
    this.transaction = this.tokenService.getAndDecodeToken();

    this.showAutoExposedTcForm = await this.iframeService.showAutoExposedTcForm();

    let walletEmbedFF = await this.featureFlagService.getFeatureFlagValue(this.transaction.ORDER_REFERENCE, FLAGS_NAME.PAYVALIDA_WALLET_EMBEBED).toPromise();

    let walletEmbedInTcFormFF = await this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.PAYVALIDA_WALLET_EMBEBED_IN_TC_FORM).toPromise();

    this.useEmbedWallet = walletEmbedFF && walletEmbedInTcFormFF;
  }

  continueWithWallet() {
    this.dialog.open(WalletDialogComponent, {
      width: '95%',
      maxWidth: '100%',
      enterAnimationDuration: '0',
      disableClose: false,
      panelClass: 'wallet-iframe-dialog',
      hasBackdrop: true,
      data: {
        info: this.wallet,
        changeMethod: this.changeMethod,
        url: environment.urlWalletLogin + '?ref=' + this.transaction.ORDER_REFERENCE,
      },
    });
  }

  initIframe(e) {
    this.creditCardIframeElement = document.getElementById('creditCardIframe') as HTMLIFrameElement;

    this.creditCardIframeElement.contentWindow?.postMessage(JSON.stringify({ type: FLUTTER_POST_MESSAGE_TO_SEND.LOAD_WEB_SCRIPT }), environment.modulesPayvalidaUrl);

    this.onActivate();
  }

  changeMethod = () => this.TC.emit();

  onActivate() {
    window.scroll(0, 0);

    window.addEventListener('message', async (event) => {
      debugLog({ event, info: this.info });

      if (event.origin !== environment.modulesPayvalidaUrl) return;

      let data = JSON.parse(event.data);

      switch (data.type) {
        case FLUTTER_POST_MESSAGE_TYPES.IS_LOADING:
          this.loading = data.data;
          if (!this.loading && !this.displayMessage) this.displayMessage = true;

          break;
        case FLUTTER_POST_MESSAGE_TYPES.FORM_READY:
          this.transaction = this.tokenService.getAndDecodeToken();

          debugLog({ transaction: this.transaction });

          let userInformation = {
            is_recharge: false,
            user_full_Name: `${this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.firstname ?? ''} ${
              this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.lastname ?? ''
            }`.trim(),
            user_di: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.document?.id ?? '',
            user_di_type: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.document?.type ?? '',
            country_code: +this.transaction.COUNTRY_CODE,
            user_phone: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.contact_information?.phone ?? '',
            session_token: this.tokenService.getToken(),
            session_token_email: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.contact_information?.email ?? '',
            session_token_phone: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.contact_information?.phone ?? '',
            currency_code: this.transaction.ORDER_CURRENCY,
            address_line1: this.transaction.ADDITIONAL_INFORMATION?.client?.address?.line1 ?? '',
            address_line2: this.transaction.ADDITIONAL_INFORMATION?.client?.address?.line2 ?? '',
            address_postal_code: this.transaction.ADDITIONAL_INFORMATION?.client?.address?.postalCode ?? '',
            merchant: this.transaction.MERCHANT_ID,
            created_order_response: {
              amount: this.transaction.ORDER_AMOUT,
              operation: 'CREADA',
              order_id: this.transaction.ORDER_CODE,
              pv_order_id: this.transaction.ORDER_CODE,
              reference: this.transaction.ORDER_REFERENCE,
              checkout: window.location.href,
            },
          };

          debugLog(
            JSON.stringify({
              type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
              data: userInformation,
            })
          );

          this.creditCardIframeElement.contentWindow?.postMessage(
            JSON.stringify({
              type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
              data: userInformation,
            }),
            environment.modulesPayvalidaUrl
          );

          this.isVisible$.subscribe((isVisible) => {
            if (isVisible) {
              this.creditCardIframeElement.contentWindow?.postMessage(
                JSON.stringify({
                  type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
                  data: userInformation,
                }),
                environment.modulesPayvalidaUrl
              );
            }
          });

          break;

        case FLUTTER_POST_MESSAGE_TYPES.ERROR:
          this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING);
          break;
        case FLUTTER_POST_MESSAGE_TYPES.CONTENT_SIZE:
          this.creditCardIframeElement.setAttribute('height', data.data);
          break;
        case FLUTTER_POST_MESSAGE_TYPES.STATUS_CHANGE:
          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.INIT_KOUNT_VALIDATION) this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_TRANSACTION;

          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.KOUNT_VALIDATION_SUCCESS) this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.CONTACTING_BANK;

          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.OTP_CHALLENGE_REQUIRED) {
            this.loading = false;
            this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.WAITING_BANK_RESPONSE;
          }

          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.ANTI_FRAUD_VALIDATED) this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_BANK_RESPONSE;

          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.ANTI_FRAUD_FAILED) this.loading = false;

          if (data.data === FLUTTER_TC_FORM_STATUS_TYPES.FAILED || data.data === FLUTTER_TC_FORM_STATUS_TYPES.REJECTED) {
            this.loading = false;

            this.alertService.showAlert(ALERT_ERRORS.ERROR_TRY_AGAIN_WITH_ANOTHER_CARD, ALERT_ICON_CONSTANTS.ERROR, ALERT_ERRORS.PAYMENT_REJECTED);

            this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_TRANSACTION;
          }

          break;
        case FLUTTER_POST_MESSAGE_TYPES.SCROLL:
          if (screen.width < 768 || this.showAutoExposedTcForm) {
            window.scrollBy(0, data.data);

            break;
          }

          let scrollable: any = document.getElementsByClassName('methodInfo')[0];
          scrollable.scrollBy(0, data.data);
          break;
        case FLUTTER_POST_MESSAGE_TYPES.COMPLETE:
          let dataResponse = JSON.parse(data.response);

          this.response = {
            CODE: API_V4_RESPONSE_NETWORK_CODES.APROVED,
            DATA: {
              transaction: {
                cardNumber: data.card,
                cus: dataResponse.payment_authorization_data.cus,
                numAprobacion: dataResponse.payment_authorization_data.approval_number,
                accountType: 'CREDITO',
                franchise: TC_FRANCHISE_FROM_FLUTTER[data.franchise],
                responseCode: ORDER_STATES.APPROVED,
              },
              commerce: { net: this.transaction.COUNTRY_CODE },
            },
          };

          this.authService.setTC(this.response);

          if (await this.iframeService.showAutoExposedTcForm()) {
            await this.router.navigate(['checkout/whiteVoucher']);

            return;
          }

          await this.router.navigate(['checkout/alertTC']);

          this.loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_TRANSACTION;
          this.displayMessage = false;
          break;
        default:
          break;
      }
    });
  }

  getDate() {
    const date = new Date();

    let merchantTimeZone = COMMERCIAL_NETWORKS_TIMEZONES.COL;

    const dateTimeFormat = new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: merchantTimeZone,
    });

    const [{ value: month }, , { value: day }, , { value: year }, , { value: hour }, , { value: minute }, , { value: second }, , { value: dayPeriod }] = dateTimeFormat.formatToParts(date);

    return `${year}-${month}-${day} ${hour}:${minute}:${second} ${dayPeriod}`;
  }

  getCountryCode() {
    switch (this.info.template) {
      case PAYMENTEZ.id:
      case COOPENAE.id:
      case REDEBAN.id:
      case LAFISE.id:
      case NIUBIZ.id:
      case MOVII.id:
      default:
    }
  }
}
